import {
  ExtendedRouterProps,
  PropsResolvers,
  Resolver,
} from '@wellyes/react-router-extended/dist/router/types';
import type { RoutableRoute, RoutableTab } from '@models/classes/route-group';
import type { MapRouterFn } from '@models/types/map-router-fn';

export const routeMapper: MapRouterFn<ExtendedRouterProps> = (
  route: RoutableRoute,
) => ({
  path: route.path,
  component: route.component,
  ...(route.guards.length
    ? {
        guards: route.guards,
        redirectUrl: route.redirectURL,
      }
    : {}),
  ...(route.resolvers.length
    ? {
        resolvers: route.resolvers.reduce(
          (acc: PropsResolvers, resolver: Resolver, index: number) => ({
            ...acc,
            [index.toString()]: resolver,
          }),
          {},
        ),
      }
    : {}),
  ...(route.tabs.length
    ? {
        childs: route.tabs
          .filter(
            (tab: RoutableTab) => !tab.isLink || !tab.pathToOpenInNewWindow,
          )
          .map(routeMapper),
      }
    : {}),
  exact: route.exact,
});
